import {ColumnStore, WidgetColumn} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";

class UserGrantViewButtonColumn extends WidgetColumn {
  static get $name() {
    return "UserGrantViewButtonColumn";
  }

  static get type() {
    return WIDGET_KEYS.swivuUserGrantViewButtonColumn;
  }

  static get defaults() {
    return {
      id: "grantViewButton",  // this id is being somewhere else in this file below
      text: "Permissions",
      flex: 1,
      editor: false,
      type: "widget",
      groupable: false,
      widgets: [{
        type: "button",
        rendition: "text",
        cls: "b-transparent dark:text-[#c0c1c2] text-[#3a3733]",
        icon: "fa-solid fa-eye",
        text: "View",
        onClick: "up.onExpanderToggleHandler",
      }]
    }
  }

  swivuIsButtonDisabled(record) {
    return !(Boolean(record.roles) && !record.isDeactivated);
  }

  renderer({ widgets, record }) {
    const viewButton = widgets[0];
    viewButton.disabled = this.swivuIsButtonDisabled(record);
  }
}

ColumnStore.registerColumnType(UserGrantViewButtonColumn);
